<script lang="ts">
	import classNames from 'classnames';
	import { createEventDispatcher } from 'svelte';
	import type { z } from 'zod';
	export let value: number | undefined = undefined;
	export let id: string;
	export let placeholder: string = '0';
	export let label: string;
	export let required = false;
	export let error: string | undefined = undefined;
	export let disabled = false;
	export let schema: z.ZodTypeAny | undefined = undefined;
	export let forceShowErrors = false;

	let showErrors = false;

	$: if (value) validate();
	let element: HTMLInputElement | null = null;
	const validate = () => {
		if ((!forceShowErrors && !showErrors) || !schema || element?.value === '')
			return;
		const result = schema.safeParse(element?.value);
		if (!result.success) {
			error = result.error.flatten().formErrors[0] || undefined;
		} else {
			error = undefined;
		}
	};
</script>

<div class={classNames('mb-4 w-full', $$props.class)}>
	<label for={id} class="label">
		<span class="label-text">{label}</span>
		{#if required}
			<span class="label-text font-light">Required</span>
		{/if}
	</label>
	<div class="relative rounded-md shadow-sm">
		<div
			class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
		>
			<span class="text-gray-500 sm:text-sm">₳</span>
		</div>
		<input
			bind:value
			type="number"
			min="0"
			name={id}
			{id}
			class="input-bordered input block w-full rounded-full pl-7 pr-12 focus:border-primary-focus focus:ring-primary-focus sm:text-sm"
			{placeholder}
			aria-describedby="{id}-currency"
			{disabled}
			class:input-error={error && (showErrors || forceShowErrors)}
			on:blur|once={() => {
				error = undefined;
				showErrors = true;
			}}
			on:blur={validate}
			bind:this={element}
			on:input={validate}
			on:paste={validate}
			on:change={validate}
			on:focus={() => {
				if (value === 0) value = undefined;
			}}
			on:blur
			on:change
			on:input
		/>
		<div
			class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
		>
			<span class="text-gray-500 sm:text-sm" id="{id}-currency">ADA</span>
		</div>
	</div>
	{#if error && (showErrors || forceShowErrors)}
		<label for={id}>
			<ul class="p-1">
				<li class="text-xs text-notify-error">{error}</li>
			</ul>
		</label>
	{:else}
		<li class="text-xs text-error opacity-0">There are no errors</li>
	{/if}
</div>
